var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShip2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.00002 23.5H14.65C16.594 23.5 18.5225 23.2415 20.3825 22.7325C22.031 22.281 24.318 22 26.3505 22H29C28.855 22.185 28.785 22.4 28.785 22.605C28.785 22.94 28.975 23.24 29.35 23.335C29.73 23.435 30 23.775 30 24.17C30 25.18 29.18 26 28.17 26H1.75002C1.40502 26 1.09002 25.86 0.865015 25.635C0.640015 25.41 0.500015 25.095 0.500015 24.75C0.500015 24.06 1.00002 23.5 2.00002 23.5Z",
    fill: "#157FFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50002 18H19L21 15.5H32C31.492 17.7805 30.549 19.6805 29.7005 21H26.35C24.235 21 21.8465 21.2945 20.1175 21.7675C18.344 22.2535 16.504 22.5 14.6495 22.5H1.62502C1.04601 20.8865 -0.000484467 17.6705 -0.000484467 15.5H6.99952L8.50002 18ZM4.50002 20H3.50002C3.22351 20 3.00002 20.2235 3.00002 20.5C3.00002 20.7765 3.22351 21 3.50002 21H4.50002C4.77652 21 5.00002 20.7765 5.00002 20.5C5.00002 20.2235 4.77652 20 4.50002 20ZM6.50002 20.5C6.50002 20.7765 6.72351 21 7.00002 21H8.00002C8.27652 21 8.50002 20.7765 8.50002 20.5C8.50002 20.2235 8.27652 20 8.00002 20H7.00002C6.72351 20 6.50002 20.2235 6.50002 20.5Z",
    fill: "#157FFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5 9.5H23V11.5H29.5V9.5Z",
    fill: "#157FFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 12.5H9.00002V14.5H15V12.5Z",
    fill: "#157FFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5 12.5H23V14.5H29.5V12.5Z",
    fill: "#157FFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 7H9.00002V9H15V7Z",
    fill: "#157FFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11.5H9.00002V10.5V10H15V11.5Z",
    fill: "#157FFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7H16V9H22.5V7Z",
    fill: "#157FFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12.5H16V14.5H22V12.5Z",
    fill: "#157FFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.50002 10.5V14.5H1.52588e-05V11L1.00002 10.5H3.50002Z",
    fill: "#157FFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 7.75V14.5H4.50002V10C4.50002 9.7235 4.27652 9.5 4.00002 9.5H2.00002V8H3.50002C3.77652 8 4.00002 7.7765 4.00002 7.5C4.00002 7.2235 3.77652 7 3.50002 7H2.00002V6H1.50002C1.22352 6 1.00002 5.7765 1.00002 5.5C1.00002 5.2235 1.22352 5 1.50002 5H2.50002V3C2.50002 2.7235 2.72352 2.5 3.00002 2.5C3.27652 2.5 3.50002 2.7235 3.50002 3V5H4.50002V4C4.50002 3.7235 4.72352 3.5 5.00002 3.5C5.27652 3.5 5.50002 3.7235 5.50002 4V5H7.00002C7.27652 5 7.50002 5.2235 7.50002 5.5C7.50002 5.7765 7.27652 6 7.00002 6H6.50002V7L8.00002 7.75ZM6.00002 13C6.27602 13 6.50002 12.776 6.50002 12.5C6.50002 12.224 6.27602 12 6.00002 12C5.72402 12 5.50002 12.224 5.50002 12.5C5.50002 12.776 5.72402 13 6.00002 13ZM6.00002 10C5.72402 10 5.50002 10.224 5.50002 10.5C5.50002 10.776 5.72402 11 6.00002 11C6.27602 11 6.50002 10.776 6.50002 10.5C6.50002 10.224 6.27602 10 6.00002 10Z",
    fill: "#157FFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 10H16V11.5H22V10Z",
    fill: "#157FFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 17V15.5H19.7L18.5 17H16Z",
    fill: "#157FFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 17H9.00001L8.10001 15.5H15V17Z",
    fill: "#157FFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "matrix(-1 0 0 1 32 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip2);
export default __webpack_public_path__ + "static/media/ship2.d6510590f15e3351744a2e482df8b77b.svg";
export { ForwardRef as ReactComponent };